import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=cbf137f4&scoped=true"
import script from "./custom-table.vue?vue&type=script&lang=js"
export * from "./custom-table.vue?vue&type=script&lang=js"
import style0 from "./custom-table.vue?vue&type=style&index=0&id=cbf137f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf137f4",
  null
  
)

export default component.exports